exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form__location[data-v-2c0a4f28] {\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  -webkit-box-ordinal-group: 3;\n      -ms-flex-order: 2;\n          order: 2;\n}\n.form__background img[data-v-2c0a4f28] {\n  width: 100%;\n}\n.form__group[data-v-2c0a4f28] {\n  width: 100%;\n}\n.debug[data-v-2c0a4f28] {\n  max-width: 100%;\n  display: block;\n}", ""]);

// exports
